<script>
import {mixin} from './mixin.js'
export default {
  name: 'cmp-loader',
  mixins: [mixin]
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/cmp-loader/cmp-loader.vue